<template>
  <div class="container-income-report">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow>
        <template #left>
          <div style="display: flex; align-items: center" @click="goPrevious">
            <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" />
            <span class="tit-left">
              {{ $t('lang.mybean.incomeReport') }}
            </span>
          </div>
        </template>
        <template #right>
          <div class="search-select" @click="handleTimePop">
            <span v-if="chooseTime">{{ handleTime4(chooseTime) }}</span>
            <span v-else>{{ $t('lang.dl.thisWeek') }}</span>
            <img :class="{ activeTime: showPop }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="myincome-list">
        <div
          class="list-item"
          :class="{ todayIncome: key == $t('lang.mybean.todaytIncome'), lineBottom: key == $t('lang.mybean.todaytIncome') || key == $t('lang.mybean.others') }"
          v-for="key in list.keys()"
          :key="key"
        >
          <span>{{ key }}</span>
          <div class="myincome-beans">
            <i>{{ list.get(key) }}</i>
            <img :src="getMatchImg('beans')" alt="" />
          </div>
        </div>
      </div>
      <div class="title">{{ $t('lang.mybean.todayPerformance') }}</div>
      <div class="performance-data">
        <div class="perfor-item">
          <span>{{ formatSecondsTime(data.onlineDuration) }}</span>
          <span>{{ $t('lang.mybean.onlineDuration') }}</span>
        </div>
        <div class="perfor-item">
          <span>{{ formatSecondsTime(data.videoCallDuration) }}</span>
          <span>{{ $t('lang.earnRule.callDuration') }}</span>
        </div>
        <div class="perfor-item">
          <span>{{ data.repliedUsersCount }}</span>
          <span>{{ $t('lang.mybean.repliedUsers') }}</span>
        </div>
      </div>

      <table class="table" cellspacing="0" cellpadding="0">
        <tr>
          <td rowspan="5" class="video-call-ms">{{ $t('lang.mybean.videoCall') }}</td>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.privateCallTimes') }}</span>
              <span>{{ data.privateCallSuccessTimes }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.matchCallTimes') }}</span>
              <span>{{ data.videoPassTodayIncomeAmount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.missedCallTimes') }}</span>
              <span>{{ data.missedCallTimes }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.answerRate') }}</span>
              <span>{{ data.answeringRate }}%</span>
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.incomeRate') }}</span>
              <span>{{ data.incomeRate }}%</span>
            </div>
          </td>
        </tr> -->
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.videoCallDuration') }}</span>
              <span>{{ this.formatSeconds(data.videoCallDuration) }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td rowspan="6" class="video-call-ms">{{ $t('lang.mybean.message') }}</td>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.sentMessage') }}</span>
              <span>{{ msgInfo.sendMsgCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.messageReceived') }}</span>
              <span>{{ msgInfo.receivedCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.profitableMessage') }}</span>
              <span>{{ msgInfo.profitableMessagesCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.chatUsers') }}</span>
              <span>{{ msgInfo.chatUsersCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.repliedUsers') }}</span>
              <span>{{ msgInfo.repliedUsersCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.mybean.messageReplyRate') }}</span>
              <span>{{ msgInfo.chatUsersRepliedRate }}%</span>
            </div>
          </td>
        </tr>
      </table>

      <div class="tips">{{ $t('lang.mybean.tips') }}</div>
      <div class="tips tips-text">{{ $t('lang.mybean.tipsText') }}</div>
    </div>
    <TimeDay :showPop="showPop" @handleCurrentDate="handleCurrentDate"></TimeDay>
  </div>
</template>

<script>
import CTimeDay from '@/components/CTimeDay'
import { apiFetchReportDetail } from '@/api/imee'
import moment from 'moment'

export default {
  components: {
    TimeDay: CTimeDay
  },
  props: {},
  data() {
    let query = this.$route.query
    return {
      date: query.date || null,
      showPop: false,
      chooseTime: query.date || new Date(),
      data: {},
      listMap: new Map(),
      msgInfo: {},
      scene: query.scene || null
    }
  },
  created() {
    this.fetchReportDetail()
  },
  mounted() {},
  methods: {
    toPage(path) {
      this.$router.push({
        path
      })
    },
    // handleBackPath() {
    //   if (this.scene) {
    //     this.closeWeb()
    //   } else {
    //     this.goPrevious()
    //   }
    // },
    // 打开日期选择
    handleTimePop() {
      this.showPop = true
    },
    // 关闭弹框
    closePop() {
      this.showPop = false
    },
    // 根据时间刷选
    handleCurrentDate(time) {
      this.chooseTime = moment(time).format('yyyy-MM-DD')
      this.fetchReportDetail(this.chooseTime)
    },

    fetchReportDetail(val) {
      let date = this.date || moment(new Date()).format('yyyy-MM-DD')
      apiFetchReportDetail(date).then((res) => {
        if (res) {
          this.data = res
          this.msgInfo = res && res.chatMsgInfo
        }
      })
    }
  },
  watch: {},
  computed: {
    list() {
      this.listMap.set(this.$t('lang.mybean.todaytIncome'), this.data.todayIncomeAmount)
      this.listMap.set(this.$t('lang.mybean.privateCalls'), this.data.videoCallTodayIncomeAmount)
      this.listMap.set(this.$t('lang.mybean.matchCalls'), this.data.videoPassTodayIncomeAmount)
      this.listMap.set(this.$t('lang.intimate.message'), this.data.messageTodayIncomeAmount)
      this.listMap.set(this.$t('lang.mybean.gifts'), this.data.giftTodayIncomeAmount)
      this.listMap.set(this.$t('lang.mybean.bonus'), this.data.bonusTodayIncomeAmount)
      this.listMap.set(this.$t('lang.mybean.others'), this.data.otherTodayIncomeAmount)
      // this.list.set(this.$t('lang.mybean.onlineDuration'), this.formatSeconds(res.onlineDuration)) // 返回的是多少秒 需要处理成xxm xxm xxs
      // this.list.set(this.$t('lang.mybean.videoCallTimes'), res.timesOfVideoCall)
      // this.list.set(this.$t('lang.mybean.videoCallDuration'), this.formatSeconds(res.videoCallDuration)) //返回的是多少秒 需要处理成xxm xxm xxs
      // this.list.set(this.$t('lang.mybean.answeringRate'), res.answeringRate + '%') // 返回的是数字  需要加百分号
      // this.list.set(this.$t('lang.mybean.messageReply'), res.replyMessageUsers) //
      return this.listMap
    }
  }
}
</script>
<style lang="scss" scoped>
.container-income-report {
  width: 100%;
  min-height: 100vh;
  background: #fff;
}

.search-select {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 22px;
  margin-top: 4px;
  background: #f9f9fb;
  border-radius: 6px;
  text-align: center;
  line-height: 22px;
  font-size: 11px;
  font-family: Inter-Regular;
  font-weight: 400;
  color: #666666;
  > img {
    width: 10px;
    margin-left: 4px;
  }
  .activeTime {
    transform: rotateX(180deg);
  }
}
.main {
  width: 100%;
  height: 100%;
  padding: 0 24px 30px;
}
.myincome-list {
  width: 100%;
  margin-top: 30px;
  .list-item {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    color: #333;
    font-weight: 500;
    font-size: 14px;
    > span {
      display: block;
      white-space: nowrap;
      font-family: Inter-Medium;
      line-height: 17px;
    }
    .myincome-beans {
      display: flex;
      i {
        display: block;
        margin: 0 4px;
        color: #666666;
      }
      > img {
        width: 20px;
        height: 20px;
        position: relative;
        top: -2px;
      }
    }
  }
  .todayIncome {
    color: #a337fc;
    font-weight: 600;
    font-family: Inter-SemiBold;
    > span {
      font-family: Inter-SemiBold;
    }
    .myincome-beans {
      i {
        color: #a337fc;
      }
    }
  }
  .lineBottom {
    margin-bottom: 20px;
    border-bottom: 1px solid #f7e4ff;
  }
}
.title {
  height: 20px;
  font-family: Inter-Regular;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.performance-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
  font-family: Inter-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  .perfor-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    > span:nth-child(1) {
      height: 20px;
      font-weight: 600;
      font-size: 14px;
      color: #a337fc;
      line-height: 20px;
    }
  }
}

.table {
  width: 100%;
  margin-bottom: 20px;
  border: 1px solid #ecc3ff;
  font-family: Inter-Regular;
  tr,
  td {
    height: 40px;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    border: 1px solid #f7e4ff;
    background-color: #fefaff;
  }
  .video-call-ms {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    line-height: 17px;
    background-color: #fbf2ff;
  }
  td {
    padding: 0 10px;
    .td-con {
      display: flex;
      justify-content: space-between;
      > span:nth-child(2) {
        color: #333333;
        font-weight: 600;
      }
    }
  }
}

.tips {
  font-family: Inter-Regular;
  font-size: 14px;
  color: #666666;
}
.tips-text {
  display: block;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}

::v-deep .van-nav-bar__title {
  color: #000;
  font-weight: bold;
  font-size: 17px;
  font-family: F-Medium;
}
</style>
